import { AlertTriangle, Wand2 } from "lucide-react";
import { lintPortugueseFormality, autofixPortugueseFormality } from "@/lib/ptLinter";

/**
 * Banner discreto que aparece abaixo de um textarea quando detecta
 * infracções às convenções PT da Caring (ex.: "Senhora Albertina" em
 * vez de "Senhora Dona Albertina"). O operador pode ignorar ou clicar
 * "Corrigir" para aplicar todas as sugestões de uma vez.
 *
 * Uso:
 *   <textarea value={x} onChange={...} />
 *   <PtFormalityHint text={x} onFix={(fixed) => setX(fixed)} />
 */
export default function PtFormalityHint({ text, onFix, className = "" }) {
  const warnings = lintPortugueseFormality(text || "");
  if (warnings.length === 0) return null;

  return (
    <div
      role="status"
      data-testid="pt-formality-hint"
      className={`mt-2 rounded-md border border-[hsl(var(--warning))]/40 bg-[hsl(var(--warning-bg))] px-3 py-2.5 text-sm text-[hsl(var(--warning))] flex items-start gap-2.5 ${className}`}
    >
      <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="font-semibold mb-1">Convenção Caring:</div>
        <ul className="list-disc list-inside space-y-0.5 text-[13px] leading-relaxed break-words">
          {warnings.map((w, i) => (
            <li key={i} data-testid={`pt-formality-warning-${i}`}>
              {w.hint}
            </li>
          ))}
        </ul>
      </div>
      {onFix && (
        <button
          type="button"
          onClick={() => onFix(autofixPortugueseFormality(text))}
          data-testid="pt-formality-fix-btn"
          className="inline-flex items-center gap-1 shrink-0 text-xs font-semibold rounded-full bg-amber-600 hover:bg-amber-700 text-primary-foreground px-3 py-1.5"
        >
          <Wand2 className="w-3.5 h-3.5" /> Corrigir
        </button>
      )}
    </div>
  );
}
